import {
  beSMSSendConfirmSmsNumericSender,
  TRUSTED_SMS_CONFIRM_STATUS_VALID,
  TRUSTED_SMS_CONFIRM_STATUS_WRONG,
  TRUSTED_SMS_CONFIRM_STATUS_REVOKED,
  TRUSTED_SMS_CONFIRM_STATUS_EXPIRED
} from 'Api/beSMSSendApi'
import { logAppError } from 'Helpers/logger'
import {
  toastShow,
  TOAST_VARIANT_ERROR,
  TRUSTED_SMS_BOX_CODE_VARIANT_NEUTRAL,
  TRUSTED_SMS_BOX_CODE_VARIANT_INVALID,
  TRUSTED_SMS_INPUT_VARIANT_SUCCESS
} from 'mailup-web-components'
import { pageState } from 'Pages/Workflow/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { atomFamily, useRecoilState, useSetRecoilState } from 'recoil'

import { trustedSmsSenderState } from './useTrustedSmsSender'

export const trustedSmsSenderCodeState = atomFamily({
  key: 'trustedSmsSenderState',
  default: {
    value: '',
    isError: false,
    isDirty: false,
    invalidWrong: false,
    invalidExpired: false,
    invalidRevoked: false,
    variant: TRUSTED_SMS_BOX_CODE_VARIANT_NEUTRAL
  }
})

export async function confirmSmsNumericSender(SenderNumber, ConfirmationCode) {
  const result = await beSMSSendConfirmSmsNumericSender(
    SenderNumber,
    ConfirmationCode
  )
  return result
}

export const useTrustedSmsSenderCode = (itemKey, itemKeyInputSender) => {
  const intl = useIntl()
  const placeholder = intl.formatMessage({
    id: 'Load.TrustedSmsSender.SmsCodeLabel'
  })

  const [
    { value, variant, invalidWrong, invalidExpired, invalidRevoked },
    setState
  ] = useRecoilState(trustedSmsSenderCodeState(itemKey))

  const [
    { value: SenderNumber, trustedSmsBoxCodeVisible },
    setTrustedSmsSenderState
  ] = useRecoilState(trustedSmsSenderState(itemKeyInputSender))

  const setPageState = useSetRecoilState(pageState)

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      invalidWrong: false,
      invalidExpired: false,
      invalidRevoked: false
    }))
  }, [trustedSmsBoxCodeVisible])

  const handleChange = ({ target: { value } }) => {
    innerHandleChange(value)
  }
  const innerHandleChange = async (inputVal) => {
    setState((prev) => ({
      ...prev,
      value: inputVal,
      invalidWrong: false,
      invalidExpired: false,
      invalidRevoked: false
    }))
  }

  const handleVerifyButtonClick = async () => {
    setPageState((prev) => ({
      ...prev,
      loading: true
    }))
    try {
      const { ValidationResult } = await confirmSmsNumericSender(
        SenderNumber,
        value
      )
      // const { ValidationResult } = {"Status":"ToBeConfirmed","ValidationResult":{"Code":"Valid","Description":"Confirmation code not valid."}}
      const confirmStatus = ValidationResult.Code

      if (confirmStatus === TRUSTED_SMS_CONFIRM_STATUS_VALID) {
        setTrustedSmsSenderState((prev) => ({
          ...prev,
          variant: TRUSTED_SMS_INPUT_VARIANT_SUCCESS,
          trustedSmsBoxCodeVisible: false
        }))
      } else {
        setState((prev) => ({
          ...prev,
          invalidWrong: confirmStatus === TRUSTED_SMS_CONFIRM_STATUS_WRONG,
          invalidExpired: confirmStatus === TRUSTED_SMS_CONFIRM_STATUS_REVOKED,
          invalidRevoked: confirmStatus === TRUSTED_SMS_CONFIRM_STATUS_EXPIRED,
          variant: TRUSTED_SMS_BOX_CODE_VARIANT_INVALID
        }))
      }
    } catch (error) {
      toastShow(
        intl.formatMessage({
          id: 'Load.Common.LoadingDataError'
        }),
        TOAST_VARIANT_ERROR
      )

      logAppError({
        appError: error,
        Component: 'useTrustedSmsSenderCode',
        Method: 'handleVerifyButtonClick'
      })
    }
    setPageState((prev) => ({
      ...prev,
      loading: false
    }))
  }

  const i18n = {
    invalid: invalidWrong
      ? intl.formatMessage({ id: 'Load.TrustedSmsSender.CodeWrong' })
      : invalidRevoked
        ? intl.formatMessage({
            id: 'Load.TrustedSmsSender.CodeRevoked'
          })
        : invalidExpired
          ? intl.formatMessage({
              id: 'Load.TrustedSmsSender.CodeExpired'
            })
          : undefined,
    label: intl.formatMessage({
      id: 'Load.TrustedSmsSender.SmsInputCodeLabel'
    }),
    verifyButton: intl.formatMessage({
      id: 'Load.TrustedSmsSender.SmsConfirmCode'
    })
  }

  return {
    value,
    onChange: handleChange,
    onVerifyButtonClick: handleVerifyButtonClick,
    variant,
    i18n,
    placeholder,
    buttonVerifyDisabled: !value
  }
}
